<template>
    <div class="body-panel dataContent">
        <div class="body-panel-control separator">

            <div class="control-block-left" v-if="info.User">
                <div class="flex mob-inline">
                    <p class="btn-back margin-right-10">
                        <a class="router-link-active" href="" @click.prevent="back">Назад</a>
                    </p>
                    <div class="form-field margin-right-10">
                        <drop-down
                                :items="[{Id: '', Name: 'Все'},
                                {Id: 10, Name: 'Начисление'},
                                {Id: 20, Name: 'Возврат'},
                                {Id: 21, Name: 'Расход'},
                                {Id: 22, Name: 'Отмена отчёта'},
                                {Id: 23, Name: 'Заморозка баллов'}]"
                                :dataField="'Id'"
                                :textField="'Name'"
                                v-model="bonusOperationTypeId"
                                @change="historyReload"
                                ></drop-down>
                    </div>
                    <div class="form-field">
                        <p class="menu-item-info grey" style="white-space:nowrap;">{{formatInt(total || 0) }}</p>
                    </div>
                </div>
            </div>
            <div class="control-block-right">
                <div class="flex mob-inline">
                    <button type="button" class="btn" @click="onExport">Экспорт</button>
                </div>
            </div>

            <div class="body-panel-control-separator flex">
                <complex-filter ref="complexFilter"
                                :filters="monthFilters"
                                :searchFunction="searchFunction"
                                @onFilterChange="onFilterChange"></complex-filter>
            </div>

            <div class="body-panel-control-separator flex">
                <input type="text" class="input-text" v-model="search" placeholder="Поиск" @input="onSearchChange()" />
            </div>
        </div>

        <div class="body-panel-content body-panel-content-page" v-if="project != null">
            <div class="block-in-page" v-if="info.User && hasClaims(info.User.DynamicRole, claimEnums.bonusSpend) && project.RewardUnitTypeId === 1">
                <div style="height:250px">
                    <chart :chartData="chartData" :chartOptions="chartOptions"></chart>
                </div>
            </div>
            <div v-if="isMobile" class="block-in-page">
                <div v-for="item of data" :class="['table-div', {'': item.BonusOperationTypeId === 0, 'ball-add': item.BonusOperationTypeId === 10, 'ball-off': item.BonusOperationTypeId !== 10, 'ball-used': item.BonusSpent, 'ball-burned': item.BonusBurned}]">
                    <div class="caption-help">
                        {{ formatDate(item.CreateDate, 'DD.MM.YYYY HH:mm') }}, {{ item.OperationTypeName }}
                    </div>
                    <div class="flex margin-top-5" style="font-weight:600;font-size:14px">
                        <div style="width:50%;">Сумма</div>
                        <div style="width:50%;text-align:right">{{ formatInt(item.Amount) }}</div>
                    </div>
                    <div class="flex margin-top-2">
                        <div style="width:50%">Дата активации</div>
                        <div style="width:50%;text-align:right">{{ formatDate(item.BonusStartDate, 'DD.MM.YYYY HH:mm') }}</div>
                    </div>
                    <div class="flex margin-top-2">
                        <div style="width:50%">Дата сгорания</div>
                        <div style="width:50%;text-align:right">{{ formatDate(item.BonusEndDate, 'DD.MM.YYYY HH:mm') }}</div>
                    </div>
                    <div class="caption-help margin-top-2">
                        {{ item.TradePointName }}
                    </div>
                    <div class="caption-help margin-top-2">
                        {{ item.Comment }}
                    </div>
                </div>
            </div>
            <table class="table-view margin-top-20" v-if="!isMobile">
                <thead class="head-show">
                    <tr style="text-align: center;">
                        <th>Тип операции</th>
                        <th class="value-center">Кол-во</th>
                        <th class="datetime">Дата операции</th>
                        <th class="datetime" v-if="project.RewardUnitTypeId === 1">Дата активации</th>
                        <th class="datetime" v-if="project.RewardUnitTypeId === 1">Дата сгорания</th>
                        <th>Торговая точка</th>
                        <th>Комментарий</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item of data" :class="{'ball-add': item.BonusOperationTypeId === 10, 'ball-off': item.BonusOperationTypeId !== 10, 'ball-used': item.BonusSpent, 'ball-burned': item.BonusBurned}">
                        <td>{{ item.OperationTypeName }}</td>
                        <td class="value-center">{{ formatInt(item.Amount) }}</td>
                        <td class="datetime">{{ formatDate(item.CreateDate, 'DD.MM.YYYY HH:mm') }}</td>
                        <td class="datetime" v-if="project.RewardUnitTypeId === 1">{{ formatDate(item.BonusStartDate, 'DD.MM.YYYY HH:mm') }}</td>
                        <td class="datetime" v-if="project.RewardUnitTypeId === 1">{{ formatDate(item.BonusEndDate, 'DD.MM.YYYY HH:mm') }}</td>
                        <td>{{ item.TradePointName }}</td>
                        <td>{{ item.Comment }}</td>
                    </tr>
                </tbody>
            </table>

        </div>

            <vue-headful title="История начислений баллов" />
        </div>
</template>

<script>
    import $ from 'jquery'
    import UI from '../helpers/ui-helpers'
    import BackendApi from '../backendApi'
    import projectMixin from '../helpers/project-mixin'
    import claimsCheckingMixin from '../helpers/claims-checking-mixin'
    import moment from 'moment'
    import _ from 'lodash'
    import config from '../config'

    let backendApi = new BackendApi();

    let months = [{Id: 1, Name: 'Январь'}, {Id: 2, Name: 'Февраль'}, {Id: 3, Name: 'Март'}, {Id: 4, Name: 'Апрель'},
        {Id: 5, Name: 'Май'}, {Id: 6, Name: 'Июнь'}, {Id: 7, Name: 'Июль'}, {Id: 8, Name: 'Август'},
        {Id: 9, Name: 'Сентябрь'}, {Id: 10, Name: 'Октябрь'}, {Id: 11, Name: 'Ноябрь'}, {Id: 12, Name: 'Декабрь'}];

    export default {
        name: "bonus-history",

        mixins: [projectMixin, claimsCheckingMixin],

        data(){
            return{
                data: [],
                loading: false,
                canBeLoaded: true,
                page: 1,
                rowsPerPage: 100,
                dateStart: null,
                dateEnd: null,
                accrued: null,
                charged: null,
                total: null,
                project: null,
                isMobile: UI.check_mobile(),
                bonusOperationTypeId: null,
                search: null,
                chartData: null,
                chartOptions: null,
                filter: null,
                monthFilters: [
                    {
                        Value: 'Month', Name: 'Месяц'
                    }
                ]
            }
        },

        methods: {

            searchFunction(tableName, columnName, search, filters, searchPage, callback, errorCallback) {

                let vm = this;
                let dateStart = moment(vm.dateStart, 'DD.MM.YYYY').format();
                let dateEnd = moment(vm.dateEnd, 'DD.MM.YYYY').format();
                let monthAndYear = null;
                if(filters && filters.length){
                    monthAndYear = filters[0][2].replace("('", "").replace("')", "").replace("';'", ",");
                }
                let bonusOperationTypeId = vm.bonusOperationTypeId;

                this.callApiWrapper(backendApi.bonusHistoryDistinctValues(columnName, dateStart, dateEnd, bonusOperationTypeId, search, monthAndYear,(searchPage - 1) * 30, 30, vm.projectId))
                    .then(function (resp) {
                        if(!resp.hasError){
                            callback(resp.data);
                        }
                        else{
                            errorCallback(resp.message);
                        }
                    });
            },

            onFilterChange(filter) {
                this.filter = filter;

                this.historyReload();

            },

            back() {
                this.$router.back();
            },

            historyReload() {
                if (!moment(this.dateStart, 'DD.MM.YYYY').isValid()) {
                    //this.dateStart = this.formatDate(moment().startOf('month'));
                }
                else {
                    this.dateStart = this.formatDate(moment(this.dateStart, 'DD.MM.YYYY').startOf('month'));
                }
                //this.$refs.dateStart.setDate(this.dateStart);

                if (!moment(this.dateEnd, 'DD.MM.YYYY').isValid()) {
                    //this.dateEnd = this.formatDate(moment().endOf('month'));
                }
                else {
                    this.dateEnd = this.formatDate(moment(this.dateEnd, 'DD.MM.YYYY').endOf('month'));
                }
                //this.$refs.dateEnd.setDate(this.dateEnd);
                this.page = 1;
                this.data = [];
                this.loadNext();
            },

            onSearchChange: _.debounce(function () {

                this.historyReload();

            }, 500),

            loadNext(){
                let vm = this;
                this.loading = true;
                UI.blockUI('.dataContent', 'Загрузка...');

                let dateStart = moment(vm.dateStart, 'DD.MM.YYYY').format();
                let dateEnd = moment(vm.dateEnd, 'DD.MM.YYYY').format();
                let unit = 'day';
                if(vm.isMobile){
                    unit = 'week';
                }
                let monthAndYear = null;
                this.filter = this.$refs.complexFilter.getExpotData();
                if(this.filter && this.filter.length){
                    monthAndYear = this.filter[0][2].replace("('", "").replace("')", "").replace(/';'/g, ",");
                }
                let bonusOperationTypeId = vm.bonusOperationTypeId;
                let search = vm.search;

                this.callApiWrapper(backendApi.bonusHistoryList((this.page - 1) * this.rowsPerPage, this.rowsPerPage, dateStart, dateEnd, bonusOperationTypeId, search, unit, monthAndYear, vm.projectId))
                    .then(function (resp) {
                        if(resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки истории');
                        }
                        else{
                            if(resp.data && resp.data.items && resp.data.items.length){
                                vm.data.push(...resp.data.items);
                                vm.total = 0;
                                $.each(resp.data.chart, function (i, e) {
                                    vm.total += e.Value;
                                })
                                vm.chartData = {
                                    labels: resp.data.chart.map(x => x.Name),//['01.02.03', '05.02.03', '06.02.03'],
                                    datasets: [
                                        {
                                            label: 'Доход',
                                            data: resp.data.chart.map(x => x.Value),
                                            backgroundColor: 'rgba(255, 99, 132, 0.5)',
                                            borderColor: 'rgba(255, 99, 132, 1)',
                                            borderWidth: 1
                                        }
                                    ]
                                };
                            }
                            else{
                                vm.canBeLoaded = false;
                            }
                        }
                        UI.unblockUI('.dataContent');
                        vm.loading = false;
                    })
            },

            onExport(){
                let vm = this;
                let dateStart = moment(vm.dateStart, 'DD.MM.YYYY').toISOString(),
                    dateEnd = moment(vm.dateEnd, 'DD.MM.YYYY').toISOString(),
                    unit = 'day';
                if(vm.isMobile){
                    unit = 'week';
                }
                let monthAndYear = '';

                UI.blockUI('#app');
                vm.callApiWrapper(backendApi.bonusHistoryExport(dateStart, dateEnd, vm.bonusOperationTypeId, (vm.search ? vm.search : ''),
                    unit, monthAndYear, vm.projectId))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время экспорта');
                        }
                        else {
                            let exportFile = resp.data;
                            if (exportFile != null) {
                                UI.downloadFileByBytes(exportFile, 'История начислений.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                            }
                        }

                        UI.unblockUI('#app');
                    });
            },

            loadProject(){
                let vm = this;

                return this.callApiWrapper(backendApi.projectLoad(vm.projectId)).then(function (resp) {
                    if (resp.data) {
                        vm.project = resp.data;
                    }
                });
            }
        },

        mounted(){
            let vm = this;

            // vm.dateStart = vm.formatDate(moment().startOf('month'));
            // vm.dateEnd = vm.formatDate(moment().endOf('month'));

            let currentYear = new Date().getFullYear();
            let month = months[new Date().getMonth()];

            vm.$refs['complexFilter'].applyFilter();
            vm.$refs['complexFilter'].filterRowSetValues([{Id: (month.Id > 9 ? month.Id : '0' + month.Id) + '.' + currentYear, Name: month.Name + ' ' + currentYear}]);


            vm.loadProject().then(function () {
                vm.loadNext();
            });

            vm.$nextTick(() => {

                $('.body-panel-content').on('scroll', function () {

                    if(!vm.loading && vm.canBeLoaded) {
                        let elem = $(this);
                        if (elem[0].scrollHeight - elem.scrollTop() - 200 <= elem.outerHeight()) {
                            vm.page++;
                            vm.loadNext();
                        }
                    }
                });



            });

            let options = {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                },
                maintainAspectRatio: false,
                responsive: true,
                stacked: false,
                defaultFontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                legend: {
                    display: false
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            let label = data.datasets[tooltipItem.datasetIndex].label || '';

                            label += ': ' + vm.formatInt(tooltipItem.yLabel) ;

                            return label;
                        },
                    }
                },
                maintainAspectRatio: false
            };

            vm.chartOptions = options;
        },

        destroyed(){
            $('.body-panel-content').off('scroll');
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Content/src/views/BonusHistory.vue